/* eslint react/prop-types: 0 */
import React, { Component } from 'react';
import {Modal} from 'react-bootstrap';

class SiteOneModal extends Component {
  render() {
    const {closeButton, title, children, onHide, ...other} = this.props;
    return (
      <div className='root-modal'>
        <Modal container={this} {...other}>
          <Modal.Header closeButton={!!closeButton} onHide={onHide}>
            <Modal.Title>{title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {children}
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default SiteOneModal;



// WEBPACK FOOTER //
// ./src/components/modal/index.js